/*
 * @Author: chenjianxiong 2232943862@qq.com
 * @Date: 2025-10-27 09:09:29
 * @LastEditors: chenjianxiong 2232943862@qq.com
 * @LastEditTime: 2026-03-10 09:21:47
 * @FilePath: \easyrent_front\src\api\tool.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '../util/request';
import axios from 'axios';
import { authUtils } from "../util/auth";

export const getDistData = (data: any) => {
  return request({
    url: '/rent/distData/types',
    method: 'post',
    data
  })
};
//根据Type获取地区
export const getAreaByType = (params: any) => {
  return request({
    url: '/rent/area/getAreaByType/' + params.areaType,
    method: 'get',
    params
  })
}

export const getDistTypesData = (data: any) => {
  return request({
    url: '/rent/distData/types/list',
    method: 'post',
    data
  })
};
export const getImage = async (fileId: string) => {
  // return request({
  //   url: `/file/preview/file/${fileId}`,
  //   method: 'get'
  // })
  const response = await axios({
    method: 'get',
    url: `/dev-api/file/preview/file/${fileId}`, // 例如: 'https://example.com/image.png'
    responseType: 'blob',// 重要：指定返回类型为blob
    headers: {
      Authorization: "Bearer " + authUtils.getToken()
    }
  })
  // response.data 是一个 Blob 对象
  const blob = response.data;
  const blobUrl = URL.createObjectURL(blob);
  console.log('blobUrl', blobUrl)
  console.log(blob); // 查看 Blob 对象
  // 你可以使用这个 Blob 对象进行进一步操作，例如创建 URL 或者下载文件
};
